import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { addDoc, collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../firebaseConfig';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../firebaseConfig';
import './form.css'
import Swal from 'sweetalert2';
// Schéma de validation
const appointmentSchema = yup.object().shape({
  fullName: yup.string().required('Fullname is required'),
  email: yup.string().email('Email is invalid').required('Email is required'),
  phone: yup.string().matches(/^[0-9]+$/, 'Phone number invalid').required('Phone number is required'),
  service: yup.string().required('Service is required'),
  date: yup.date()
    .min(new Date(), "The Date can't be into the past")
    .required('Date is required'),
  time: yup.string().required('Hour is required'),
  notes: yup.string().max(200, 'Maximum 200 caracters')
});

const AppointmentForm = () => {
  const [user] = useAuthState(auth);
  const { register, handleSubmit, formState: { errors }, reset } = useForm({
    resolver: yupResolver(appointmentSchema)
  });

  const services = [
    'Initial Consultation',
    'Project Follow-up',
    'Technical Meeting',
    'Product Demo',
    'others'
  ];

  const timeSlots = [
    '09:00', '10:00', '11:00', '13:00', '14:00', '15:00', '16:00'
  ];

  const checkAvailability = async (date, time) => {
    const q = query(
      collection(db, "appointments"),
      where("date", "==", date),
      where("time", "==", time)
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.empty;
  };

  const onSubmit = async (data) => {
    console.log("Données du formulaire:", data);
    try {
      const isAvailable = await checkAvailability(data.date, data.time);
      
      if (!isAvailable) {
       Swal.fire({
            title: 'Appointment failed',
            text: "Sorry, but this time slot  is already been taken, try another one",
            icon: 'error',
            confirmButtonText: 'close' } )
        return;
      }

      const appointmentData = {
        ...data,
        userId: user?.uid || null,
        createdAt: new Date(),
        status: 'confirmed'
      };

      await addDoc(collection(db, "appointments"), appointmentData);
      Swal.fire({
            title: 'Appointment succeed',
            text: "Thank you for taking an appointment with us, we're going to answer you soon!",
            icon: 'success',
            confirmButtonText: 'close' } )
      reset();
    } catch (error) {
      console.error("Erreur lors de l'enregistrement: ", error);
     Swal.fire({
            title: 'Appointment failed',
            text: "Sorry, your process to get an appointment failed, try again and check any case ",
            icon: 'error',
            confirmButtonText: 'close' } )
    }
  };

  return (
    <div className="appointment-form-container" id='form'>
      <h2>Take an appointment </h2>
      <form onSubmit={handleSubmit(onSubmit)} className="appointment-form">
        <div className="form-group">
          <label>FullName</label>
          <input 
            {...register("fullName")} 
            placeholder="Your fullname" 
          />
          {errors.fullName && <span className="error">{errors.fullName.message}</span>}
        </div>

        <div className="form-group">
          <label>Email</label>
          <input 
            type="email" 
            {...register("email")} 
            placeholder="your@email.com" 
          />
          {errors.email && <span className="error">{errors.email.message}</span>}
        </div>

        <div className="form-group">
          <label>Phone number</label>
          <input 
            type="tel" 
            {...register("phone")} 
            placeholder="0612345678" 
          />
          {errors.phone && <span className="error">{errors.phone.message}</span>}
        </div>

        <div className="form-group">
          <label>Service</label>
          <select {...register("service")}>
            <option value="">Choose a service</option>
            {services.map((service, index) => (
              <option key={index} value={service}>{service}</option>
            ))}
          </select>
          {errors.service && <span className="error">{errors.service.message}</span>}
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Date</label>
            <input 
              type="date" 
              {...register("date")} 
              min={new Date().toISOString().split('T')[0]} 
            />
            {errors.date && <span className="error">{errors.date.message}</span>}
          </div>

          <div className="form-group">
            <label>Hour</label>
            <select {...register("time")}>
              <option value=""> Select an hour</option>
              {timeSlots.map((time, index) => (
                <option key={index} value={time}>{time}</option>
              ))}
            </select>
            {errors.time && <span className="error">{errors.time.message}</span>}
          </div>
        </div>

        <div className="form-group">
          <label>More informations</label>
          <textarea 
            {...register("notes")} 
            placeholder="More informations..." 
            rows="3"
          />
          {errors.notes && <span className="error">{errors.notes.message}</span>}
        </div>

        <button type="submit" className="submit-btn"> Confirm your appointment</button>
      </form>
    </div>
  );
};

export default AppointmentForm;